import { configureStore } from "@reduxjs/toolkit";
import usersReducers from "./Users/UsersSlice";
import compsReducers from "./Comps/CompsSlice";
import ApplicantSlice from "./Users/ApplicantSlice";
import logger from "redux-logger";
import { apiSlice } from "./Api/ApiSlice";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import Cookies from "js-cookie";
import { AllCookiesName } from "../Imports/CookiesName";
import ResponsesSlice from "./Responses/ResponsesSlice";
import studentsReducer from "./Users/StudentsSlice"; // Import the new slice

export const LocalStoreName = process.env.REACT_APP_REDUX_STORAGE_NAME;

function saveToLocalStorage(state) {
  try {
    const temp = { ...state };
    delete temp.api;
    let userName = temp?.users?.user?.userName;
    if (Cookies.get(AllCookiesName.userName) === userName) {
      const serialState = JSON.stringify(temp);
      localStorage.setItem(LocalStoreName, serialState);
    }
  } catch (e) {
    console.warn(e);
  }
}
function loadFromLocalStorage() {
  try {
    const serialState = localStorage.getItem(LocalStoreName);
    if (serialState === null) return undefined;
    return JSON.parse(serialState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}

let middleware = [apiSlice.middleware];
if (process.env.REACT_APP_REDUX_LOGGER === "true") {
  middleware.push(logger);
}

const Store = configureStore({
  reducer: {
    users: usersReducers,
    comps: compsReducers,
    applicant: ApplicantSlice,
    responses: ResponsesSlice,
    students: studentsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
  preloadedState: loadFromLocalStorage(),
});

Store.subscribe(() => saveToLocalStorage(Store.getState()));

setupListeners(Store.dispatch);

export default Store;
